export default __webpack_public_path__ + "static/media/Integra.47cd2c3335e079dd080b605475ff639b.webp";